interface SectionHeadingProps {
  title: string
  subtitle?: string
  eyebrow?: string
  align?: 'left' | 'center'
  className?: string
  titleClassName?: string
  as?: 'h1' | 'h2'
}

export function SectionHeading({
  title,
  subtitle,
  eyebrow,
  align = 'left',
  className = '',
  titleClassName = '',
  as: Heading = 'h2',
}: SectionHeadingProps) {
  return (
    <div className={`${align === 'center' ? 'text-center mx-auto' : ''} max-w-3xl ${className}`}>
      {eyebrow && (
        <span className="inline-block text-xs font-semibold uppercase tracking-[0.18em] text-brand mb-3">
          {eyebrow}
        </span>
      )}
      <Heading className={`font-display text-h2 text-heading ${titleClassName}`}>
        {title}
      </Heading>
      <div
        className={`mt-4 h-1 w-16 rounded-full bg-brand ${align === 'center' ? 'mx-auto' : ''}`}
        aria-hidden="true"
      />
      {subtitle && (
        <p className="text-text text-lg leading-relaxed mt-5">{subtitle}</p>
      )}
    </div>
  )
}
